"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.apiDescriptor = {
    key: key => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(key) ? key : JSON.stringify(key),
    value(value) {
        if (value === null || typeof value !== 'object') {
            return JSON.stringify(value);
        }
        if (Array.isArray(value)) {
            return `[${value
                .map(subValue => exports.apiDescriptor.value(subValue))
                .join(', ')}]`;
        }
        const keys = Object.keys(value);
        return keys.length === 0
            ? '{}'
            : `{ ${keys
                .map(key => `${exports.apiDescriptor.key(key)}: ${exports.apiDescriptor.value(value[key])}`)
                .join(', ')} }`;
    },
    pair: ({ key, value }) => exports.apiDescriptor.value({ [key]: value }),
};
